// ========== Auth URL ==========
export var AUTH_URL = 'auth';
export var LOGIN_URL = 'login';
export var HOME_URL = '/';
// ========== Account Management URL ==========
export var ACCOUNT_MANAGEMENT_URL = '/account-management';
// ========== CF Overview URL ==========
export var CF_OVERVIEW_URL = '/cashflow/cf-overview';
// ========== CF Statement URL ==========
export var CF_STATEMENT_URL = '/cashflow/cf-statement';
export var VIEW_CF_STATEMENT_URL = CF_STATEMENT_URL + '/:id';
export var EDIT_CF_STATEMENT_URL = VIEW_CF_STATEMENT_URL + '/edit';
export var CREATE_CF_STATEMENT_URL = CF_STATEMENT_URL + '/create';
// ========== CF Template URL ==========
export var CF_TEMPLATE_URL = '/cashflow/cf-template';
export var CREATE_CF_TEMPLATE_URL = CF_TEMPLATE_URL + '/create';
export var VIEW_CF_TEMPLATE_URL = CF_TEMPLATE_URL + '/:id';
export var EDIT_CF_TEMPLATE_URL = VIEW_CF_TEMPLATE_URL + '/edit';
// ========== Multi Language URL ==========
export var MULTI_LANGUAGE_URL = '/multi-languages';
// ========== Dept Management URL ==========
export var DEPT_MANAGEMENT_URL = '/dept-management';
// ========== AggregrateCf URL ==========
export var AGGREGRATE_CF_URL = '/cashflow/aggregrate-cf';
// ========== SupplierManagement URL ==========
export var SUPPLIER_MANAGEMENT_URL = '/ap-management/supplier-management';
// ========== SupplierBalance URL ==========
export var SUPPLIER_BALANCE_URL = '/ap-management/supplier-balance';
export var VIEW_SUPPLIER_BALANCE_URL = SUPPLIER_BALANCE_URL + '/:supplierCode/:year';
export var SUPPLIER_LINE_ITEMS_URL = SUPPLIER_BALANCE_URL + '/supplier-line-items' + '/:supplierCode/:year/:period';
// ========== ApOverview URL ==========
export var AP_OVERVIEW_URL = '/ap-management/ap-overview';
// ========== ArOverview URL ==========
export var AR_OVERVIEW_URL = '/ar-management/ar-overview';
// ========== CustomerManagement URL ==========
export var CUSTOMER_MANAGEMENT_URL = '/ar-management/customer-management';
// ========== CustomerBalance URL ==========
export var CUSTOMER_BALANCE_URL = '/ar-management/customer-balance';
export var VIEW_CUSTOMER_BALANCE_URL = CUSTOMER_BALANCE_URL + '/:customerCode/:year';
export var CUSTOMER_LINE_ITEMS_URL = CUSTOMER_BALANCE_URL + '/customer-line-items' + '/:customerCode/:year/:period';
// ========== Payment URL ==========
export var PAYMENT_URL = '/automation/payment';
export var VIEW_PAYMENT_URL = PAYMENT_URL + '/payment-log';
export var CREATE_PAYMENT_URL = PAYMENT_URL + '/create';
export var EDIT_PAYMENT_URL = PAYMENT_URL + '/:id';
// ========== DunningLetter URL ==========
export var DUNNING_LETTER_URL = '/automation/dunning-letter';
export var VIEW_DUNNING_LETTER_URL = DUNNING_LETTER_URL + '/execution-log';
export var CREATE_DUNNING_LETTER_URL = DUNNING_LETTER_URL + '/create';
export var EDIT_DUNNING_LETTER_URL = DUNNING_LETTER_URL + '/edit/:id';
export var LETTER_LAYOUT_URL = '/automation/payment/letter-layout';
